
import Range from 'vux/src/components/range/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'

import { getQueryVariable, system, isApp } from '@/util/const'
import shareDownload from './shareDownload'

export default {
components: {
XProgress,
Range,
shareDownload
},
data () {
return {

src: decodeURIComponent(this.$route.query.src || ''),
title: decodeURIComponent(this.$route.query.title || ''),
downUrl: '',
video: null,
percent: 0,
allTime: '00:00',
currentTime: '00:00',
isFull: false,
isPlay: true,
itemHeight: 0,
itemWidth: 0,
duration: 0,
currentDate: 0,
isNext: false,
isApp: isApp()
}
},
mounted () {
const id = getQueryVariable('id')
this.downUrl = system() === 'ios' ? 'https://itunes.apple.com/hk/app/mylink-hk/id483513425?mt=8' : 'market://details?id=com.ChinaMobile'


if (id) {
this.$http.post(`/v1/api/video/getVideoInfoById`, { id }).then((res) => {

if (res.header.resultCode === 0) {

let lang = localStorage.getItem('lang')
let title = JSON.parse(res.body.title)
document.title = lang === 'tc' ? title[0] : lang === 'sc' ? title[1] : title[2]
this.src = res.body.origin_url
this.$nextTick(() => {
this.initVideo()
})
}
})
}

if (this.src) {
document.title = this.title
this.$nextTick(() => {
this.initVideo()
})
}
},
methods: {
initVideo () {
this.video = document.getElementById('player')
this.video.onloadedmetadata = () => {
this.duration = this.video.duration
this.allTime = this.timeStamp(this.video.duration)
}
this.video.ontimeupdate = () => {
this.currentDate = this.video.currentTime
if (this.currentDate === this.duration) {
this.video.pause()
this.isPlay = true
}
this.percent = 100 * (this.currentDate / this.duration)
this.currentTime = this.timeStamp(this.currentDate)
}
let dom = document.getElementsByClassName('range-handle')
dom[0].addEventListener('touchend', () => {
this.changePro()
})
},
changePro (val) {
this.video.currentTime = this.duration * (this.percent / 100)
this.video.play()
},

timeStamp (secondTime) {
let time1 = ((parseInt(secondTime) / 100)).toString()
let time2 = time1.split('.')[1] ? (time1.split('.')[1].length === 1 ? time1.split('.')[1] + '0' : time1.split('.')[1]) : '00'
let time = '00' + ':' + time2
if (parseInt(secondTime) > 60) {
let second = ((parseInt(secondTime) % 60) / 100).toString()
let min = (parseInt(secondTime / 60) / 100).toString()
let time3 = second.split('.')[1] ? (second.split('.')[1].length === 1 ? second.split('.')[1] + '0' : second.split('.')[1]) : '00'
let time4 = min.split('.')[1] ? (min.split('.')[1].length === 1 ? min.split('.')[1] + '0' : min.split('.')[1]) : '00'
time = time4 + ':' + time3
}
return time
},
playVideo () {
if (this.video.paused) {
this.video.play()
this.isPlay = false
} else {
this.video.pause()
this.isPlay = true
}
return false
},
fullScreen () {
if (this.isFull) {
this.isFull = false
} else {
this.itemWidth = document.documentElement.clientHeight + 'px'
this.itemHeight = document.documentElement.clientWidth + 'px'
this.isFull = true
}
}
}
}



// WEBPACK FOOTER //
// ./src/page/videoPlay.vue